module.exports = __webpack_public_path__ + "img/whatsapp.3d91a09.png";